import { db } from "config/firebaseConfig";
import { doc, onSnapshot } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FaAndroid,
  FaApple,
  FaAppStoreIos,
  FaBatteryEmpty,
  FaBatteryFull,
  FaBatteryHalf,
  FaBatteryQuarter,
  FaBatteryThreeQuarters,
  FaSignal,
  FaWifi,
} from "react-icons/fa";
import { GiRadarSweep } from "react-icons/gi";
import { MdSignalWifiConnectedNoInternet0 } from "react-icons/md";
import Card from "components/Card";
// import Map from "components/Map";
// import GoogleMapWrapper from "components/GoogleMapWrapper";
import AnotherMap from "components/AnotherMap";
const DeviceDetails = () => {
  const { deviceId, userId } = useLocation().state;
  const [device, setDevice] = useState(null);
  const {
    brand,
    deviceName,
    modelName,
    year,
    osName,
    osVersion,
    modelId,
    battery,
    network,
    tracking,
    location,
  } = device ?? {};

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, `users/${userId}/devices`, deviceId),
      (device) => {
        setDevice(device.data());
      }
    );
    return () => {
      unsub();
    };
  }, [deviceId, userId]);

  return (
    device && (
      <div className="flex flex-col w-full h-full">
        <div className="flex px-5 space-x-5 items-center text-xl">
          <h1 className="text-4xl font-sans">{deviceName}</h1>

          <span
            className={`${tracking ? " text-green-400" : " text-slate-400"}`}
          >
            {tracking ? "Active" : "Inactive"}
          </span>

          {device.tracking ? (
            <GiRadarSweep className="w-8 h-8 animate-spin text-green-400" />
          ) : (
            <GiRadarSweep className="w-8 h-8" />
          )}
        </div>

        <div className="grid grid-cols-4 gap-x-4  text-sm">
          <Card title={"Device"}>
            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>Brand</span>
              <div className="flex items-center  justify-between px-2">
                <span className=" bg-header/80 py-1 px-3 rounded-md">
                  {brand}
                </span>
                {brand === "Apple" ? (
                  <FaApple className="w-6 h-6 text-white" />
                ) : (
                  <FaAndroid className="w-6 h-6 text-green-500" />
                )}
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>Model</span>
              <div className="flex items-center  w-full whitespace-nowrap  justify-end px-2">
                <span>{modelName}</span>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>Model ID</span>
              <div className="flex items-center  w-full whitespace-nowrap  justify-end px-2">
                <span>{modelId}</span>
              </div>
            </div>
            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>Year </span>
              <div className="flex items-center  justify-end px-2">
                <span>{year}</span>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>OS </span>
              <div className="flex items-center  justify-between px-2">
                <span className=" bg-header/80 py-1 px-3 rounded-md">
                  {osName}
                </span>
                <FaAppStoreIos className="w-6 h-6" />
              </div>
            </div>
            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>OS Version </span>
              <div className="flex items-center  justify-end px-2">
                <span>{osVersion}</span>
              </div>
            </div>
          </Card>

          <Card title="Battery">
            <div className="grid grid-rows-1 grid-cols-2  text-base items-center justify-between">
              <span>Status </span>
              <div className="flex items-center  justify-end px-2">
                <span>{battery.state}</span>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2  text-base items-center justify-between">
              <span>Level </span>
              <div className="flex items-center  justify-end px-2">
                <span>{battery.level}%</span>
              </div>
            </div>

            <div className="text-4xl">
              {battery.level <= 5 ? (
                <FaBatteryEmpty className=" text-red-700" />
              ) : battery.level <= 25 ? (
                <FaBatteryQuarter className=" text-red-500" />
              ) : battery.level <= 50 ? (
                <FaBatteryHalf className=" text-yellow-300" />
              ) : battery.level <= 75 ? (
                <FaBatteryThreeQuarters className=" text-orange-400" />
              ) : (
                battery.level <= 100 && (
                  <FaBatteryFull className=" text-green-500" />
                )
              )}
            </div>
          </Card>

          <Card title="Network">
            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>Network </span>
              <div className="flex items-center  justify-between px-2">
                <span>
                  {network.details.strength && network.details.strength}%
                </span>
                <FaSignal className="w-6 h-6" />
              </div>
            </div>
            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>Connected </span>
              <div className="flex items-center  justify-between px-2">
                <span>{network.isConnected ? "Yes" : "No"}</span>
                {network.isConnected ? (
                  <FaWifi className="w-6 h-6" />
                ) : (
                  <MdSignalWifiConnectedNoInternet0 className="w-6 h-6" />
                )}
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between">
              <span>IP Address </span>
              <div className="flex items-center  justify-between px-2">
                <span>{network.details.ipAddress}</span>
              </div>
            </div>
          </Card>

          <Card title="Location">
            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between text-lg whitespace-nowrap">
              <span>Longitude </span>
              <div className="flex items-center  justify-between px-2">
                <span>
                  {Math.fround(location.coords.longitude).toFixed(6)}&deg;
                </span>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2  items-center justify-between text-lg whitespace-nowrap">
              <span>Latitude </span>
              <div className="flex items-center  justify-between px-2">
                <span>
                  {Math.fround(location.coords.latitude).toFixed(6)}&deg;
                </span>
              </div>
            </div>
          </Card>
        </div>

        {/* <Map location={location} zoom={20} /> */}
        {/* <GoogleMapWrapper location={location} zoom={20} /> */}
        <AnotherMap location={location.coords} />
      </div>
    )
  );
};

export default DeviceDetails;
